(function initialiseMicroportCategoryRails() {
const initialiseRail = rail => {
  if (rail.dataset.mpRailReady === 'true') return;
  rail.dataset.mpRailReady = 'true';
  const section = rail.closest('[data-mp-rail]');
  const pagination = section?.querySelector('[data-mp-rail-pagination]');
  const navigation = pagination?.closest('.mp-rail-pagination');
  const items = () => [...rail.querySelectorAll(':scope > li')];
  let pageStarts = [];

  const getVisibleItems = () => {
    const firstItem = items()[0];
    if (!firstItem) return 1;
    const styles = window.getComputedStyle(rail);
    const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
    const itemWidth = firstItem.getBoundingClientRect().width;
    return Math.max(1, Math.floor((rail.clientWidth + gap) / (itemWidth + gap)));
  };

  const targetFor = index => {
    const item = items()[index];
    const maxScroll = Math.max(0, rail.scrollWidth - rail.clientWidth);
    const relativeLeft = item ? item.getBoundingClientRect().left - rail.getBoundingClientRect().left + rail.scrollLeft : 0;
    return Math.min(Math.max(0, relativeLeft), maxScroll);
  };

  const updateCurrentPage = () => {
    if (!pagination || pageStarts.length === 0) return;
    const activePage = pageStarts.reduce((nearest, start, index) => (
      Math.abs(rail.scrollLeft - targetFor(start)) < Math.abs(rail.scrollLeft - targetFor(pageStarts[nearest])) ? index : nearest
    ), 0);
    [...pagination.querySelectorAll('[data-mp-rail-dot]')].forEach((dot, index) => {
      if (index === activePage) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });
  };

  const renderPagination = () => {
    if (!pagination) return;
    const itemCount = items().length;
    const visibleItems = getVisibleItems();
    const pageCount = Math.ceil(itemCount / visibleItems);
    pageStarts = Array.from({ length: pageCount }, (_, index) => Math.min(index * visibleItems, itemCount - 1));
    navigation.hidden = pageCount <= 1;
    pagination.replaceChildren();
    pageStarts.forEach((start, index) => {
      const listItem = document.createElement('li');
      const dot = document.createElement('button');
      dot.className = 'mp-rail-pagination__dot';
      dot.type = 'button';
      dot.dataset.mpRailDot = '';
      dot.setAttribute('aria-controls', rail.id);
      dot.setAttribute('aria-label', `Show carousel page ${index + 1} of ${pageCount}`);
      if (index === 0) dot.setAttribute('aria-current', 'true');
      dot.addEventListener('click', () => rail.scrollTo({ left: targetFor(start), behavior: 'smooth' }));
      listItem.append(dot);
      pagination.append(listItem);
    });
    updateCurrentPage();
  };

  rail.addEventListener('scroll', updateCurrentPage, { passive: true });
  window.addEventListener('resize', renderPagination, { passive: true });
  renderPagination();
};

document.querySelectorAll('[data-mp-rail-track]').forEach(initialiseRail);
})();
